"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addClassRule = void 0;
const add_style_sheet_1 = require("./add-style-sheet");
const common_tags_1 = require("common-tags");
function addClassRule(classname, declarationBlock) {
    const stylesheet = createClassRule(classname, declarationBlock);
    return add_style_sheet_1.addStyleSheet(stylesheet);
}
exports.addClassRule = addClassRule;
function isString(val) {
    return typeof val === 'string';
}
function createClassRule(classname, declarationBlock) {
    return createRule(createSelector(classname), isString(declarationBlock)
        ? declarationBlock
        : createDeclarationBlock(declarationBlock));
}
function createRule(selector, declarationBlock) {
    return common_tags_1.stripIndents `
    ${selector} {
      ${declarationBlock}
    }
  `;
}
function createSelector(classname) {
    return `.${classname}`;
}
function createDeclarationBlock(styles) {
    const declaration = [];
    for (const [name, value] of Object.entries(styles)) {
        declaration.push(`${name}: ${value};`);
    }
    return declaration.join('\n');
}
//# sourceMappingURL=add-class-rule.js.map